"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterSignedBadge = LetterSignedBadge;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ToolsDate_1 = __importDefault(require("../../React/Tools/ToolsDate"));
const letterSignaturesStore_1 = require("./letterSignaturesStore");
/**
 * Plakietka „podpisane” przy numerze pisma w rejestrze. Klik otwiera listę podpisanych plików
 * (z odnośnikami do Dysku, nazwą podpisującego i datą). Pisma bez podpisów nie dostają niczego.
 */
function LetterSignedBadge({ letterId }) {
    const entry = (0, letterSignaturesStore_1.useLetterSignatures)(letterId);
    if (!entry || entry.count === 0)
        return null;
    const popover = (react_1.default.createElement(react_bootstrap_1.Popover, { id: `letter-signed-${letterId}`, style: { maxWidth: "460px" } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h6" }, "Podpisane pliki tego pisma"),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement("ul", { className: "list-unstyled mb-0 d-flex flex-column", style: { gap: "8px" } }, entry.signatures.map((signature) => (react_1.default.createElement("li", { key: signature.id, style: { wordBreak: "break-word" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFilePdf, className: "text-danger me-1" }),
                react_1.default.createElement("a", { href: signature.signedUrl, target: "_blank", rel: "noopener noreferrer" }, signature.signedName),
                react_1.default.createElement("div", { className: "small text-muted" },
                    signature.signerName,
                    " \u00B7 ",
                    ToolsDate_1.default.dateToDDmmmYYYYHHMM(new Date(signature.signedAt)),
                    signature.method === "MANUAL_UPLOAD" ? " · wgrany ręcznie" : ""))))))));
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { trigger: "click", rootClose: true, placement: "bottom", overlay: popover },
        react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success", role: "button", tabIndex: 0, title: "Poka\u017C podpisane pliki", style: { cursor: "pointer", fontWeight: 600 } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleCheck, className: "me-1" }),
            "podpisane",
            entry.count > 1 ? ` (${entry.count})` : "")));
}
